import { render } from "./BranchUserCreateUpdateModel.vue?vue&type=template&id=6fb39ec5"
import script from "./BranchUserCreateUpdateModel.vue?vue&type=script&lang=js"
export * from "./BranchUserCreateUpdateModel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__